import React, { useRef, useState } from "react";
import { LuImagePlus, LuPlus } from "react-icons/lu";

interface AttachmentsBtnProps {
  onAddImageClick: () => void;
  className?: string;
  iconSize?: number;
  isDisabled?: boolean;
  dropdownPosition?: "top" | "bottom";
}

export const AttachmentsBtn: React.FC<AttachmentsBtnProps> = ({
  onAddImageClick,
  className = "",
  iconSize = 24,
  isDisabled = false,
  dropdownPosition = "bottom",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAddImageClick = () => {
    setIsOpen(false);
    onAddImageClick();
  };

  return (
    <div className="relative flex gap-4 items-center" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${className} flex items-center justify-center`}
        type="button"
        disabled={isDisabled}
      >
        <LuPlus size={iconSize} />
      </button>

      {isOpen && (
        <div
          className={`absolute left-0 ${
            dropdownPosition === "top"
              ? "bottom-[calc(100%+8px)]"
              : "-bottom-14"
          } w-56 p-1 rounded-md
        bg-light-surface-primary dark:bg-[#25292D] 
        text-ligh-text dark:text-dark-text
        border border-white dark:border-[#25292D]
        shadow-[0_2px_6px_rgba(0,0,0,0.18)]`}
        >
          <div className="py-1" role="menu" aria-orientation="vertical">
            <button
              id="attachments-btn-add-image"
              onClick={handleAddImageClick}
              className="flex items-center px-4 py-1 w-full 
              hover:bg-white/60 dark:hover:bg-black/10 
              rounded-lg"
              role="menuitem"
            >
              <LuImagePlus className="mr-3 h-5 w-5" />
              Add image
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
